module.exports = __webpack_public_path__ + "media/images/platforms/steam/square-794fb2997b7fa7d5f8b52dc37c3ef621.jpg";